import { useTranslation } from 'react-i18next';
import { Head } from 'vite-react-ssg';
import { useLocale } from '../lib/use-locale';
import { brand } from '../config/brand';
import { pageRoutes } from '../config/page-routes';

export function Component() {
  const locale = useLocale();
  const { t } = useTranslation();
  const faqs = t('faq.items', { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const title = `${t('faq.title')} · ${brand.name}`;

  return (
    <>
      <Head htmlAttributes={{ lang: locale }}>
        <title>{title}</title>
        <meta name="description" content={t('faq.description')} />
        {/* FAQ content + FAQPage schema now live on the home page (the canonical
            content hub); canonicalise here to consolidate ranking signals. */}
        <link rel="canonical" href={`${brand.url}${pageRoutes.home[locale]}`} />
      </Head>
      <main id="main" className="legal-page container">
        <h1>{t('faq.title')}</h1>
        <p className="legal-page__intro">{t('faq.intro')}</p>

        <nav className="legal-page__toc" aria-label={t('faq.title')}>
          <ol>
            {faqs.map((item, i) => (
              <li key={i}>
                <a href={`#faq-${i + 1}`}>{item.q}</a>
              </li>
            ))}
          </ol>
        </nav>

        <dl className="faq-list">
          {faqs.map((item, i) => (
            <div key={i} id={`faq-${i + 1}`} className="faq-item">
              <dt className="faq-item__q">{item.q}</dt>
              <dd className="faq-item__a">{item.a}</dd>
            </div>
          ))}
        </dl>
      </main>
    </>
  );
}
